export default "__VITE_ASSET__BBhedfNz__"